module.exports = __webpack_public_path__ + "static/media/loc2_img10.617a04e7.jpg";